import { ChangeDetectorRef, Component, Input, input } from '@angular/core';

import { CommonService } from '../../services/common.service';
import { SharedModule } from '../../../shared/shared.module';

import { ActivatedRoute, Router, RouterModule } from '@angular/router';


@Component({
  selector: 'app-side-bar',
  imports: [SharedModule, RouterModule],
  templateUrl: './side-bar.html',
  styleUrls: ['./side-bar.scss']
})
export class SideBar {
 
  idenavVisible = false;
  selectedMenu: string = '';

  cRoles: string = '';
  cPath: string = '';
  isElevation: boolean = false;

  constructor(route: ActivatedRoute, public commonService: CommonService,
     public router: Router,
    private changeDetector: ChangeDetectorRef) {

    // detect current url 
    this.router.events.subscribe(() => {
      setTimeout(() => {
        // Get the full URL path from router
        const fullUrl = this.router.url;
        
        // Split the URL and get the first segment after the leading slash
        const segments = fullUrl.split('/').filter(seg => seg.length > 0);
        
        // Get the parent path (first segment)
        this.cPath = segments[0] || '';
        if(this.cPath === 'foundation'  && segments.length > 1 && segments[1] === 'elevation') {
          this.isElevation = true;
        } else {
          this.isElevation = false;
        }

        this.changeDetector.detectChanges();
      }, 0);
    });
    // 'NMAFSM.Admin',
    // 'NMAFSM.DataEntry',
    // 'NMAFSM.ReportViewer',
    // 'NMAFSM.ReportsAndData'
    // this.commonService.checkPermission('')

    this.cRoles = this.commonService.cRoles[0] || '';


  }

  showMenu(menu: string) {
    this.selectedMenu = menu;
  }

}
